import './bg-three.ts'
import { setCursorElement } from './cursor/cursor.ts'
import { linkSkillsAndProjects } from './skills.ts'
import './style.css'

linkSkillsAndProjects()

const header = document.querySelector('header')

if (!header) throw new Error('<header> element not found')

header.addEventListener('click', () => {
    setCursorElement('normal')
    window.scrollTo({ top: header.clientHeight, behavior: 'smooth' })
})

const dialogs = Array.from(
    document.querySelectorAll<HTMLDialogElement>('dialog'),
)

const cursor = document.getElementById('cursor')!

for (const dialog of dialogs) {
    const card = document.getElementById(
        dialog.id.split('-').slice(0, -1).join('-') + '-skill',
    )!

    const open = card.querySelector<HTMLButtonElement>(`button`)!

    open.addEventListener('click', (ev) => {
        dialog.append(cursor)
        dialog.showModal()
    })

    const reset = () => {
        document.body.append(cursor)
    }

    dialog.addEventListener('close', reset)
    dialog.addEventListener('cancel', reset)
}
